export const Y_VM = 225.6;
export const M_VM = 18.8;
export const M_DISC = 0.3;

export const List = {
  SaaS: {
    platform: 981,
    env: 468,
    ur: 584,
    ar: 150,
  },
  Software: {
    platform: 981,
    env: 468,
    ur: 584,
    ar: 150,
  },
};

export interface tierData {
  tier: string;
  min: number;
  max: number;
  Software: number;
  SaaS: number;
}

export const Tiers: tierData[] = [
  {
    tier: 'T4',
    min: 735000 / 12,
    max: 10000000000,
    Software: 0.35,
    SaaS: 0.3,
  },
  {
    tier: 'T3',
    min: 154000 / 12,
    max: 735000 / 12,
    Software: 0.25,
    SaaS: 0.2,
  },
  {
    tier: 'T2',
    min: 11784 / 12,
    max: 154000 / 12,
    Software: 0.15,
    SaaS: 0.1,
  },
  {
    tier: 'T1',
    min: 0,
    max: 11772 / 12,
    Software: 0.0,
    SaaS: 0.0,
  },
];
